import { useEffect, useRef } from 'react';

import type {
  IErrorHandlerBuyNow,
  IErrorResponse
} from '@/modules/buy-now/utils/error-handler/buy-now-error-handler.interfaces';
import { SendBuyNowEvents } from '@/modules/shared/utils/gtmEvents';

const extractErrorMessage = (paymentError: IErrorHandlerBuyNow): string => {
  if (paymentError.originalErrorResponse) {
    const originError: IErrorResponse = paymentError.originalErrorResponse;

    if (originError.error?.meta?.message) {
      return originError.error.meta.message;
    } else if (originError.error?.message) {
      return originError.error.message;
    }
  }

  return paymentError.message || 'Unknown error';
};

interface UseSendBuyNowErrorEventProps {
  paymentError?: IErrorHandlerBuyNow | null;
}

export const useSendBuyNowErrorEvent = ({
  paymentError
}: UseSendBuyNowErrorEventProps) => {
  const eventSentRef = useRef(false);

  useEffect(() => {
    if (!paymentError || eventSentRef.current) {
      return;
    }

    const errorCode = paymentError.errorCode || '';

    if (errorCode) {
      const errorMessage = extractErrorMessage(paymentError);

      SendBuyNowEvents.sendEvent({
        event: 'error',
        extraFields: {
          'event-interactive-tag': `${errorCode}: ${errorMessage}`
        }
      });
      eventSentRef.current = true;
    }
  }, [paymentError]);

  useEffect(() => {
    if (!paymentError) {
      eventSentRef.current = false;
    }
  }, [paymentError]);
};
